import type { Voice } from "@/app/_data/voices";
import type { DialogueItem } from "@ui/components/languages/types";

import { ttsLanguagesMap } from "@mw/shared/languagesAndAccents";
import { TTSModels } from "@mw/shared/models";

import type { MultiSpeakerSample } from "./MultiSpeakerInput";

// Helper function to convert dialogue items to MultiSpeakerSample format
export const convertDialogueToSamples = (dialogue: DialogueItem[], assignedVoices: Voice[]): MultiSpeakerSample[] => {
  const uniqueSpeakers = Array.from(new Set(dialogue.map(item => item.speaker)));

  return dialogue.map((item, index) => {
    const speakerIndex = uniqueSpeakers.indexOf(item.speaker);
    const voiceId = assignedVoices[speakerIndex % assignedVoices.length]?.voiceId || assignedVoices[0]?.voiceId;

    return {
      id: `dialogue-${index}-${Date.now()}`,
      speakerName: item.speaker,
      text: item.text,
      voiceId,
    };
  });
};

export const getDefaultTTSModel = (activeLanguage: string) => {
  const supportedModels = ttsLanguagesMap[activeLanguage]!.tts;
  if (typeof supportedModels === "object" && supportedModels[TTSModels.ELEVEN_V3]) {
    return TTSModels.ELEVEN_V3;
  }
  return TTSModels.ELEVEN_MULTILINGUAL_V2;
};

export const getAvailableTTSModels = (activeLanguage: string) => {
  const supportedModels = ttsLanguagesMap[activeLanguage]!.tts;

  return Object.entries(supportedModels || {})
    .map(([k, v]) => (v ? k : undefined))
    .filter(Boolean) as TTSModels[];
};
